import React, { useState } from 'react';
import { useJourney } from '@/context/JourneyContext';
import { CircleDollarSign, ChevronDown, ChevronUp } from 'lucide-react';

const SavingsTracker = ({ hideExplanation = false }) => {
  const { savingsData } = useJourney();
  const [showExplanation, setShowExplanation] = useState(false);

  if (!savingsData.visible) return null;

  const formattedTotal = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(savingsData.total);

  return (
    <div 
      className="sticky top-0 z-40 transition-all duration-300"
      style={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid #E5E7EB' }}
      data-testid="savings-tracker"
    >
      <div className="max-w-screen-sm mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left side: Savings display */}
          <div className="flex items-center gap-3">
            <div 
              className="w-10 h-10 rounded-full flex items-center justify-center" 
              style={{ backgroundColor: '#ECFDF3' }}
            >
              <CircleDollarSign className="w-6 h-6" style={{ color: '#10B981' }} strokeWidth={2} />
            </div>
            <div>
              <div className="text-xs font-medium" style={{ color: '#6B7280' }}>
                Potential savings so far
              </div>
              <div className="text-xl font-bold" style={{ color: '#10B981' }}>
                {formattedTotal}
              </div>
            </div>
          </div>

          {/* Right side: How we estimate - only show if not hidden */}
          {!hideExplanation && (
            <button
              onClick={() => setShowExplanation(!showExplanation)}
              className="flex items-center gap-1 text-sm font-medium transition-all hover:opacity-80 hover:underline"
              style={{ color: '#001F3F' }}
            >
              <span>How we estimate</span>
              {showExplanation ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </button>
          )}
        </div>

        {/* Explanation Panel - only show if not hidden */}
        {!hideExplanation && showExplanation && (
          <div className="mt-4 p-4 rounded-lg" style={{ backgroundColor: '#F9FAFB', border: '1px solid #E5E7EB' }}>
            <h3 className="text-sm font-bold mb-2" style={{ color: '#001F3F' }}>
              How we estimate savings
            </h3>
            <p className="text-sm leading-relaxed mb-3" style={{ color: '#4B5563' }}>
              We look at your answers and compare them to common places buyers overpay, like dealer fees, APR padding, add-ons, overpriced gap insurance, low trade-in offers, and marked-up warranties or packages. This is an educational estimate, not a guarantee of how much you will save.
            </p>
            <p className="text-xs leading-relaxed" style={{ color: '#9CA3AF' }}>
              Educational only, not financial, legal, or tax advice.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SavingsTracker;